import * as React from 'react';
import { ImgHTMLAttributes } from 'react';
import { useAsync } from 'react-async';

type AsyncImgProps = { srcPromise: Promise<string> } & ImgHTMLAttributes<HTMLImageElement>;

export const AsyncImg = ({ srcPromise, ...props }: AsyncImgProps) => {
    const { data } = useAsync({ promise: srcPromise });
    return (
        data ? <img src={data} {...props} /> : null
    );
};
